/* @flow */
import Entity from 'lib/Entity';
import apiRequest from 'lib/apiRequest';
import User from 'entities/User';

type AccessTokenPayload = {
  user?: { email: string, password: string },
  email_confirmation_token?: string,
  persist?: boolean,
  should_merge?: boolean,
};

type GoogleAuthPayload = {
  code: string,
  email_confirmation_token?: string,
};

export default class Session extends Entity {
  initialize() {
    // $FlowIssue
    this.url = '/sessions';
  }

  isNew() {
    return false;
  }

  static create(
    email: string,
    password: string,
    emailConfirmationToken: ?string = null,
    persist: boolean = false
  ): Promise<User> {
    const payload: AccessTokenPayload = {
      user: {
        email,
        password,
      },
      persist,
    };

    if (emailConfirmationToken) {
      payload.email_confirmation_token = emailConfirmationToken;
      // If user is signing in with account uid + password AND
      // email_confirmation_token, it means they want to merge.
      payload.should_merge = true;
    }

    return apiRequest('/access_tokens', 'POST', payload).then(response =>
      User.fromJSON(response.user)
    );
  }

  static createWithToken(token: string): Promise<User> {
    return apiRequest('/access_tokens', 'POST', {
      auth_token: token,
    }).then(response => User.fromJSON(response.user));
  }

  static createWithGoogleAuthorizationCode(
    code: string,
    emailConfirmationToken: ?string = null
  ): Promise<User> {
    const payload: GoogleAuthPayload = { code };
    if (emailConfirmationToken) {
      payload.email_confirmation_token = emailConfirmationToken;
    }
    return apiRequest('/users/auth/google_plus/callback', 'POST', payload, false).then(response =>
      User.fromJSON(response.user)
    );
  }

  static destroy() {
    return new Session().destroy();
  }
}
